import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  fullWidth?: boolean;
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  fullWidth = false,
  children,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-lg font-medium transition-all duration-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-[#0a1628]';
  const variants = {
    primary: 'bg-[#d4af37] text-[#0a1628] hover:bg-[#c5a028] hover:shadow-[0_0_20px_rgba(212,175,55,0.3)] focus:ring-[#d4af37]',
    secondary: 'bg-[#1e3a5f] text-white hover:bg-[#2a4d7a] focus:ring-[#1e3a5f]',
    outline: 'bg-transparent border-2 border-[#d4af37] text-[#d4af37] hover:bg-[#d4af37]/10 focus:ring-[#d4af37]'
  };
  const widthStyles = fullWidth ? 'w-full' : '';
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${widthStyles} ${className}`} {...props} data-id="element-212">
      {children}
    </motion.button>;
}